import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { AlertTriangle } from "lucide-react";

const UrgentHelpAlert = () => {
  return (
    <Alert className="mb-6 border-orange-500 bg-orange-50 dark:bg-orange-950/50">
      <AlertTriangle className="h-4 w-4 text-orange-500" />
      <AlertTitle className="text-orange-700 dark:text-orange-400">Think you've been hacked?</AlertTitle>
      <AlertDescription className="text-sm text-orange-800 dark:text-orange-300">
        <ol className="list-decimal list-inside mt-2 space-y-1">
          <li>Disconnect your device from Wi-Fi/network immediately</li>
          <li>Use another device to change your email password</li>
          <li>If money is involved, contact your bank right away</li>
          <li>Then contact us for professional incident response</li>
        </ol>
      </AlertDescription>
    </Alert>
  );
};

export default UrgentHelpAlert;
